/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';
// Platform-specific SafeAreaView edges:
// - iOS: exclude 'top' so banner extends edge-to-edge (behind notch/status bar)
// - Android: include all edges - Android handles status bar padding automatically
export const safeAreaEdges: ('top' | 'bottom' | 'left' | 'right')[] =
  Platform.OS === 'ios' ? ['left', 'right'] : ['top', 'left', 'right'];
